import { render, staticRenderFns } from "./AmetrasHeadlineFieldTemplate.vue?vue&type=template&id=763d853e&scoped=true&"
import script from "./AmetrasHeadlineFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasHeadlineFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasHeadlineFieldTemplate.vue?vue&type=style&index=0&id=763d853e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d853e",
  null
  
)

export default component.exports